import { combineReducers } from 'redux';
import { AsyncRequest } from 'angieslist-app-platform';
import categoriesActionKeys from '../../../app/common/categories/categoriesActionKeys';
import welcomeActionKeys from './welcomeActionKeys';

export default combineReducers({
  updateBusinessDescription:
    AsyncRequest.createReducer(welcomeActionKeys.UPDATE_BUSINESS_DESCRIPTION),
  categoriesToAdd:
    AsyncRequest.createReducer(categoriesActionKeys.ADD_CATEGORIES_TO_SERVICE_PROVIDER),
  serviceProviderCategories:
    AsyncRequest.createReducer(categoriesActionKeys.GET_SERVICE_PROVIDER_CATEGORIES),
});



// WEBPACK FOOTER //
// ./src/modules/home/common/welcomeReducer.js